import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { MULTIPLE_CHOICE, FREE_RESPONSE } from 'Constants/General';
import MultipleChoice from './MultipleChoice';
import FreeResponse from './FreeResponse';

export default function QuestionTypes({
  question,
  questions,
  setQuestions,
  type,
  formData,
  setFormData,
  setUnchanged,
  positionQuestion,
}) {
  if (type === undefined || !type) {
    return null;
  }
  if (type === MULTIPLE_CHOICE) {
    return (
      <Droppable key={question.id} droppableId={`dropabble_${question.id}`} type={positionQuestion}>
        {provided2 => (
          <div ref={provided2.innerRef}>
            <MultipleChoice
              question={question}
              questions={questions}
              setQuestions={setQuestions}
              formData={formData}
              setFormData={setFormData}
              positionQuestion={positionQuestion}
              setUnchanged={setUnchanged}
            />
            {provided2.placeholder}
          </div>
        )}
      </Droppable>
    );
  }
  if (type === FREE_RESPONSE) {
    return (
      <FreeResponse
        question={question}
        questions={questions}
        setQuestions={setQuestions}
        formData={formData}
        setFormData={setFormData}
        positionQuestion={positionQuestion}
        setUnchanged={setUnchanged}
      />
    );
  }
}
